module.exports = __webpack_public_path__ + "img/by_request_only_dark_icon.b75e6224.svg";